// Vendor
import $ from 'jquery';
import 'slick-carousel';
import Helper from '../helpers/util';

class SlickCarousel {
	constructor(el) {
		this.$el = $(el);

		this.initCarousel();

		this.$el.data('init', true);
	}

	initCarousel() {

		this.$el.after('<div class="carousel-nav"></div>');

		this.$navContainer = this.$el.next('.carousel-nav');

		this.$el.slick({
			dots: true,
			adaptiveHeight: true,
			infinite: true,
			prevArrow: '<button class="icon icon-chevron-left"></button>',
			nextArrow: '<button class="icon icon-chevron-right"></button>',
			appendArrows: this.$navContainer
		});
	}
}

const _init = () => {
	// Elements
	let $el = $('.carousel');
	if ($el.length) {
		$el.each((e, v) => {
			if ( !$(v).data('init') ) {
				new SlickCarousel($(v));
			}
		});
	}
};

_init();
Helper.pubsub.subscribe('initComponents', function(){
	_init();
});
